import { UseQueryResult, useQuery } from 'react-query';
import { BillingPlanRetrieve } from 'types';
import { client } from 'utils/api-client';

export default function useAthleteSalesPortalBillingPlan(
  billingPlanId: string | undefined,
): UseQueryResult<{ data: BillingPlanRetrieve }> {
  return useQuery(
    ['athleteSalesPortalBillingPlan', billingPlanId],
    () => client.get(`billing-plans/${billingPlanId}/athlete-sales-portal-retrieve`),
    {
      enabled: !!billingPlanId,
    },
  );
}
